import React from 'react';
import Button from '../../event-archive/button/Button';
import './Offer.css';

export default function Offer({ offer }) {
	return (
		<div className='offers-container'>
			<img
				className='offer-image'
				src={offer.offerImage}
				alt={offer.imageAlt}
			/>
			<p className='offer-title'>{offer.title}</p>
			<p className='offer-description'>{offer.description}</p>
			<Button link={offer.buttonUrl}>MAKE A RESERVATION</Button>
		</div>
	);
}
